/** Registry of the S-series local, owner-intent, tool and guide sheets for Home and Footer internal linking. */
export interface LocalPageEntry {
  to: string;
  sheetNo: string;
  label: string;
  area: string;
}

export const LOCAL_PAGES: LocalPageEntry[] = [
  {
    to: '/industrial-space-for-lease-cambridge',
    sheetNo: 'S-01',
    label: 'Industrial space for lease',
    area: 'Cambridge',
  },
  {
    to: '/office-space-for-lease-kitchener-waterloo',
    sheetNo: 'S-02',
    label: 'Office space for lease',
    area: 'Kitchener & Waterloo',
  },
  {
    to: '/sell-my-commercial-property-kitchener-waterloo',
    sheetNo: 'S-03',
    label: 'Sell your commercial property',
    area: 'Kitchener-Waterloo region',
  },
  {
    to: '/buying-or-selling-a-business-guelph',
    sheetNo: 'S-04',
    label: 'Buying or selling a business',
    area: 'Guelph',
  },
  {
    to: '/retail-space-for-lease-uptown-waterloo-downtown-kitchener',
    sheetNo: 'S-05',
    label: 'Retail space for lease',
    area: 'Uptown Waterloo / Downtown Kitchener',
  },
  {
    to: '/commercial-property-valuation-waterloo-region-guelph',
    sheetNo: 'S-06',
    label: 'Commercial property valuation',
    area: 'Waterloo Region & Guelph',
  },
  {
    to: '/lease-my-commercial-property-waterloo-region-guelph',
    sheetNo: 'S-07',
    label: 'Lease my commercial property',
    area: 'Waterloo Region & Guelph',
  },
  {
    to: '/sell-my-business-kitchener-waterloo-cambridge-guelph',
    sheetNo: 'S-08',
    label: 'Sell my business',
    area: 'Kitchener · Waterloo · Cambridge · Guelph',
  },
  {
    to: '/commercial-property-value-calculator',
    sheetNo: 'T-01',
    label: 'Commercial property value calculator',
    area: 'Owner tool · Waterloo Region & Guelph',
  },
  {
    to: '/commercial-lease-nnn-rent-calculator',
    sheetNo: 'T-02',
    label: 'Commercial lease & NNN rent calculator',
    area: 'Owner & tenant tool · Waterloo Region & Guelph',
  },
  {
    to: '/selling-tenanted-commercial-property-ontario',
    sheetNo: 'G-01',
    label: 'Selling a tenanted commercial property',
    area: 'Ontario owner guide',
  },
];
